module.exports = __webpack_public_path__ + "img/icon1.2a26b3ee.png";